"use client";
import { motion } from "motion/react";
import { partnersData } from "@/lib/about-data";

export default function PartnerMarquee() {
  return (
    <section className="py-24 border-b border-border dark:border-white/10 bg-white dark:bg-darkmode overflow-hidden transition-colors duration-300">
      <div className="max-w-[83.75rem] mx-auto px-6 text-center mb-12">
        <p className="text-muted font-bold uppercase tracking-widest text-sm">
          Trusted By Industry Leaders
        </p>
      </div>

      <div className="relative flex overflow-hidden group">
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white dark:from-darkmode to-transparent z-10"></div>
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white dark:from-darkmode to-transparent z-10"></div>

        <motion.div
          className="flex gap-20 whitespace-nowrap"
          animate={{ x: ["0%", "-50%"] }}
          transition={{
            repeat: Infinity,
            ease: "linear",
            duration: 40,
          }}
        >
          {/* Looping 3 times for smooth infinity effect */}
          {[...partnersData, ...partnersData, ...partnersData].map(
            (partner, index) => (
              <span
                key={index}
                className="text-4xl md:text-5xl font-bold text-gray-200 dark:text-white/10 hover:text-midnight_text dark:hover:text-white transition-colors cursor-default select-none"
              >
                {partner}
              </span>
            )
          )}
        </motion.div>
      </div>
    </section>
  );
}
